import { Component, OnInit, HostBinding } from '@angular/core';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { Toast, ToastrService, ToastPackage } from 'ngx-toastr';
import { Utils } from '../../../utils';



export class AppstoreSuccessNotificationParams
{
  constructor(public title: string = 'Notification', public text: string = '', public error: boolean = false, public image:string = "")
  {  
  }
}

@Component({
  selector: '[simple-notification]',
  template: require('./appstore-success-notification.component.html'),
  styles: [require('./appstore-success-notification.component.css')],
  animations: [
    trigger('flyInOut', [
        state('inactive', style({
            
            opacity: 0
        })),
        state('active', style({ opacity: 100 })),
        state('removed', style({ opacity: 0 })),
        transition('inactive => active', animate('{{ easeTime }}ms {{ easing }}')),
        transition('active => removed', animate('{{ easeTime }}ms {{ easing }}'))
    ])],
  preserveWhitespaces: false,
})

export class AppstoreSuccessComponent extends Toast implements OnInit {
  params: AppstoreSuccessNotificationParams;

  @HostBinding('class.error')
  get error()
  {
      return this.params.error;
  }
  

  get image()
  {
    return this.params.image
  }

  constructor(protected toastrService: ToastrService, public toastPackage: ToastPackage) 
  {
    super(toastrService, toastPackage);
    this.params = JSON.parse(Utils.decodeHTMLEntities(this.message as string));
  }

  ngOnInit() {
  }

}
